import { IGQLApiError } from "../../types"

import type { PaybisUpdateKybTcStatusMutation } from '../../__generated__/graphql'

export enum PaybisKybTcStatus {
    ACCEPTED = "accepted",
    NOT_ACCEPTED = "not_accepted",
}

export type PaybisUpdateKybTcStatusData = {
    accessToken: string
    companyId: string
    tcStatus: PaybisKybTcStatus
}

export type PaybisUpdateKybTcStatusResponse = {
    data: PaybisUpdateKybTcStatusMutation
    errors?: IGQLApiError[]
}
